import type { WorkReason } from './derived';
import { workReasonSource } from './derived';
import { LinkedText } from '../components/LinkedText';

export function WorkReasonView({ reason }: { reason: WorkReason | null }) {
  if (!reason) return <span className="dash">—</span>;
  return (
    <div className="workreason">
      <span className={'whychip ' + reason.tone}>{reason.label}</span>
      {reason.detail ? <div className="workdetail"><LinkedText text={reason.detail} /></div> : null}
      {/* Each "·" part stays whole, so a wrap never splits a date as "2026-09-" / "29". */}
      <div className="worksource" title={reason.computed_at ? `Computed ${reason.computed_at}` : undefined}>
        {workReasonSource(reason).split(' · ').map((part, index) => (
          <span className="nobr" key={index}>{index ? ' · ' : ''}{part}</span>
        ))}
      </div>
    </div>
  );
}
